import React from 'react'
import Homes from '../components/main/Homes'
import SEOHead from '../components/SEO/SEOHead'

const HomePage = () => {
  return (
    <>
      <SEOHead 
        title="Nand Blogs - Salesforce Expert Insights & Best Practices"
        description="Your ultimate Salesforce resource hub. Expert insights, best practices, tutorials, and success stories for Salesforce developers, administrators, and business users. Learn Apex, LWC, Flow, integrations, and more."
        url="https://nandblogs.com/"
        type="website"
      />
      <Homes />
    </>
  )
}

export default HomePage